/**
 * Created by Bart Decorte
 * Date: 2019-04-11
 * Time: 19:58
 */
import Page from '../../pages/Page';
import Request from '../../utils/Request';
import {
  getCurrentSelectOptionLabel,
  renderSelectOptions,
  setEnabled as setFormElementEnabled,
  setSelectOptionByLabel,
  setSelectOptionByValue,
  setSwitchEnabled,
} from '../../helpers/form_helper';
import { endpoints } from '../../utils/api';
import SettingsCollection from '../../helpers/TableColumnSettingsCollection';
import Gravity from '../../utils/Gravity';

export default class BatchImageResizeIndex extends Page {
  constructor() {
    super();
    this.bindListeners();
    this.updateActiveTable();

    this.$switch = $('.js-dont-crop').first();
    const $gravity = $('.js-gravity-value');
    const $width = $('.js-width');
    const $height = $('.js-height');
    this.gravity = new Gravity($('.js-gravity'), {
      width: this.width,
      height: this.height,
      dontCrop: this.$switch.is(':checked'),
      gravity: $gravity.val(),
    });
    this.width = $width.val();
    this.height = $height.val();
  }

  set width(width) {
    if (width === '' || typeof width === typeof undefined) {
      this._width = undefined;
    } else {
      this._width = parseInt(width);
    }
    this.gravity.width = this._width;
    this.updateDontCropState();
  }

  get width() {
    return this._width;
  }

  set height(height) {
    if (height === '' || typeof height === typeof undefined) {
      this._height = undefined;
    } else {
      this._height = parseInt(height);
    }
    this.gravity.height = this._height;
    this.updateDontCropState();
  }

  get height() {
    return this._height;
  }

  bindListeners() {
    $('.js-table-id').on('change', (ev) => this.lTableIdChanged(ev));
    $('.js-target-table-column').on('change', (ev) =>
      this.lTargetTableColumnChanged(ev)
    );
    $('.js-btn-save').on('click', (ev) => this.lBtnSaveClicked(ev));
    $('.js-width').on('input', (ev) => this.lWidthChanged());
    $('.js-height').on('input', (ev) => this.lHeightChanged());
    $('.js-dont-crop').on('change', (ev) => this.lDontCropChanged(ev));
  }

  lTableIdChanged() {
    this.updateActiveTable();
  }

  lTargetTableColumnChanged() {
    this.updateTableColumnSettings();
  }

  lBtnSaveClicked(ev) {
    ev.preventDefault();
    this.submitForm();
    return false;
  }

  lWidthChanged() {
    this.updateWidth();
  }

  lHeightChanged() {
    this.updateHeight();
  }

  lDontCropChanged(ev) {
    this.gravity.dontCrop = $(ev.target).is(':checked');
  }

  updateWidth() {
    this.width = $('.js-width').val();
    return this;
  }

  updateHeight() {
    this.height = $('.js-height').val();
    return this;
  }

  updateDontCropState() {
    this.setDontCropState(
      typeof this.width !== typeof undefined &&
        typeof this.height !== typeof undefined
    );
  }

  setDontCropState(state) {
    this.$switch.prop('disabled', state);
  }

  submitForm() {
    const $form = $('.js-main-form');
    $form.submit();
  }

  updateActiveTable() {
    const tableId = this.currentTableId();
    const tableName = this.currentTableName();

    const fetch = async (tableId, tableName) => {
      const tableColumnsResponse = await this.fetchTableColumns(tableId);
      const columnsResponse = await this.fetchColumns(tableName);

      return {
        tableColumns: tableColumnsResponse.data,
        columns: columnsResponse.data.columns,
      };
    };

    fetch(tableId, tableName)
      .then((result) => {
        this.setSourceColumnSelectOptions(result.tableColumns);
        return result;
      })
      .then((result) => {
        this.setTargetColumnSelectOptions(result.tableColumns);
        return result;
      })
      .then((result) => {
        this.setOrderColumnSelectOptions(result.columns);
        return result;
      })
      .then((result) => {
        this.updateTableColumnSettings();
        return result;
      });
  }

  updateTableColumnSettings() {
    const tableId = this.currentTableId();
    const $elt = $('.js-target-table-column');
    const tableColumnId = $elt.val();

    if (tableColumnId === null) {
      return;
    }

    this.fetchTableColumnSettings(tableId, tableColumnId)
      .then((settings) => {
        const setting = settings.byName('width');
        this.setWidth(setting ? setting.value : null);
        return settings;
      })
      .then((settings) => {
        const setting = settings.byName('height');
        this.setHeight(setting ? setting.value : null);
        return settings;
      })
      .then((settings) => {
        const setting = settings.byName('format');
        this.setFormat(setting ? setting.value : null);
        return settings;
      })
      .then((settings) => {
        const setting = settings.byName('resize_fit');
        this.setDontCrop(setting ? setting.value : false);
        return settings;
      })
      .then((settings) => {
        const setting = settings.byName('resize_fit');
        this.setDontExpand(setting ? setting.value : false);
        return settings;
      });
  }

  setWidth(width) {
    const $input = $('.js-width');
    $input.val(width);
    this.updateWidth();
    return this;
  }

  setHeight(height) {
    const $input = $('.js-height');
    $input.val(height);
    this.updateHeight();
    return this;
  }

  setFormat(format) {
    if (format !== null) {
      format = format.toLowerCase();
    }
    setSelectOptionByValue('.js-format', format);
    return this;
  }

  setDontCrop(enabled = true) {
    setSwitchEnabled('.js-dont-crop', enabled);
  }

  setDontExpand(enabled = true) {
    setSwitchEnabled('.js-dont-expand', enabled);
  }

  currentTableId() {
    const $elt = $('.js-table-id');
    return parseInt($elt.val());
  }

  currentTableName() {
    const $elt = $('.js-table-id');
    const tableId = this.currentTableId();
    return $elt.find(`option[value="${tableId}"]`).data('table-name');
  }

  fetchTableColumns(tableId) {
    const endpoint = endpoints.tableColumns(esign.info.websiteId, tableId);
    const request = new Request(endpoint, 'GET');
    return request.execute();
  }

  fetchColumns(tableName) {
    const endpoint = endpoints.columns(esign.info.websiteId, tableName);
    const request = new Request(endpoint, 'GET');
    return request.execute();
  }

  fetchTableColumnSettings(tableId, tableColumnId) {
    const endpoint = endpoints.tableColumnSettings(
      esign.info.websiteId,
      tableId,
      tableColumnId
    );
    const request = new Request(endpoint, 'GET');
    return request
      .execute()
      .then((response) => new SettingsCollection(response.data));
  }

  setTableColumnSelectOptions(selector, columnData, restoreSelection = true) {
    let optionData = columnData.filter((column) => column.type_id == 13);
    optionData = optionData.map((column) => {
      return {
        value: column.id,
        name: column.column_name,
      };
    });

    const currentLabel = getCurrentSelectOptionLabel(selector);
    $(selector).html(renderSelectOptions(optionData));

    if (restoreSelection) {
      setSelectOptionByLabel(selector, currentLabel);
    }

    return this;
  }

  setColumnSelectOptions(selector, columnData, restoreSelection = true) {
    let optionData = columnData.map((column) => {
      return {
        value: column.name,
        name: column.name,
      };
    });

    const currentLabel = getCurrentSelectOptionLabel(selector);
    $(selector).html(renderSelectOptions(optionData));

    if (restoreSelection) {
      setSelectOptionByLabel(selector, currentLabel);
    }

    return this;
  }

  setSourceColumnSelectOptions(columnData) {
    const selector = '.js-source-table-column';
    this.setTableColumnSelectOptions(selector, columnData);
    setFormElementEnabled(selector);
    return this;
  }

  setTargetColumnSelectOptions(columnData) {
    const selector = '.js-target-table-column';
    this.setTableColumnSelectOptions(selector, columnData);
    setFormElementEnabled(selector);
    return this;
  }

  setOrderColumnSelectOptions(columnData) {
    const selector = '.js-order-column';
    this.setColumnSelectOptions(selector, columnData);
    setFormElementEnabled(selector);
    return this;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/website-tools/batch-image-resize/BatchImageResizeIndex.js